import { useLazyGoogleAuthQuery } from '@entities/user';
import { useGoogleLogin } from '@react-oauth/google';

const useLogin = () => {
  const [getGoogleEmail] = useLazyGoogleAuthQuery();
  const getGoogleResponse = useGoogleLogin({
    onSuccess: async tokenResponse => {
      await getGoogleEmail(tokenResponse.access_token);
    },
  });

  return {
    getGoogleResponse,
  };
};

export default useLogin;
